import React from 'react'

import Icon1 from '../../images/ad.svg'
import Icon2 from '../../images/web.svg'
import Icon3 from '../../images/board.svg'
import Icon4 from '../../images/mobile.svg'
import Icon5 from '../../images/search.svg'
import Icon6 from '../../images/website.svg'

import {
    ServicesContainer,
    ServicesH1,
    ServicesWrapper,
    ServicesCard,
    ServicesIcon,
    ServicesH2,
    ServicesP
}from './ServiceElements' 

const Services = () => {
    return (
        <ServicesContainer id="services">
            <ServicesH1>Services</ServicesH1>
                <ServicesWrapper>
                    <ServicesCard>
                        <ServicesIcon src={Icon1}/>
                        <ServicesH2>Web Design</ServicesH2>
                        <ServicesP>Web design encompasses many different skills and disciplines in the production and maintenance of websites.</ServicesP>
                    </ServicesCard>

                    <ServicesCard>
                        <ServicesIcon src={Icon2}/>
                        <ServicesH2>Web Development</ServicesH2>
                        <ServicesP>Web development is the work involved in developing a Web site for the Internet (World Wide Web) or an intranet (a private network).</ServicesP>
                    </ServicesCard>

                    <ServicesCard>
                        <ServicesIcon src={Icon3}/>
                        <ServicesH2>Web Apps</ServicesH2>
                        <ServicesP>A web application is application software that runs on a web server, unlike computer-based software programs that are run locally on the operating system.</ServicesP>
                    </ServicesCard>

                    <ServicesCard>
                        <ServicesIcon src={Icon4}/>
                        <ServicesH2>Mobile Apps</ServicesH2>
                        <ServicesP>A computer program or software application designed to run on a mobile device such as a phone, tablet, or watch.</ServicesP>
                    </ServicesCard>

                    <ServicesCard>
                        <ServicesIcon src={Icon5}/>
                        <ServicesH2>Search Engine Optimization</ServicesH2>
                        <ServicesP>The process of manipulating the visibility of a website or a web page in search engines.</ServicesP>
                    </ServicesCard>

                    <ServicesCard>
                        <ServicesIcon src={Icon6}/>
                        <ServicesH2>Graphics Design</ServicesH2>
                        <ServicesP>Graphic design is the art whose activity consists in projecting visual communications.</ServicesP>
                    </ServicesCard>
                </ServicesWrapper>
        </ServicesContainer>
    )
}

export default Services
